<template>
  <v-row dense>
    <v-col cols="12">
      <v-text-field
        label="Identifiant"
        v-model="login"
        filled
        :rules="[requiredRule(), serverRule('login')]"
        @input="notify('login')"
        data-testid="identifiant"
      />
    </v-col>
  </v-row>
</template>

<script>
import makeValueData from "@/mixins/makeValueData";
import makeRules from "@/mixins/makeRules";
import ValueDataRules from "@/mixins/ValueDataRules";

function mapTo(src, dest) {
  dest.login = src.login;
}

export default {
  mixins: [makeRules(), makeValueData(mapTo), ValueDataRules],
};
</script>
